export default __webpack_public_path__ + "static/media/copy-solid.e5bafb58.svg";